export default {
  isObjectEmpty(object) {
    return Object.keys(object).some(key => {
      return !Object.prototype.hasOwnProperty.call(object, key);
    });
  },

  isArrayEmpty(array) {
    return !Array.isArray(array) || !array.length;
  }
};
